/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdvancedGeocodeSearchRequestDTO } from '../models';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { ComplexGeoSearch200Response } from '../models';
// @ts-ignore
import type { GeoSearch200Response } from '../models';
// @ts-ignore
import type { Geocode200Response } from '../models';
// @ts-ignore
import type { GetRoute200Response } from '../models';
// @ts-ignore
import type { GetRouteRequestDTO } from '../models';
// @ts-ignore
import type { GetWhat3WordsCoordinates200Response } from '../models';
// @ts-ignore
import type { GetWhat3WordsWords200Response } from '../models';
// @ts-ignore
import type { ReverseGeocode200Response } from '../models';
/**
 * GeoApi - axios parameter creator
 */
export const GeoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the position based on the query and additional body parameters.
         * @summary Search for a position, with additional options
         * @param {AdvancedGeocodeSearchRequestDTO} advancedGeocodeSearchRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complexGeoSearch: async (advancedGeocodeSearchRequestDTO: AdvancedGeocodeSearchRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advancedGeocodeSearchRequestDTO' is not null or undefined
            assertParamExists('complexGeoSearch', 'advancedGeocodeSearchRequestDTO', advancedGeocodeSearchRequestDTO)
            const localVarPath = `/api/nora/geo/complex-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedGeocodeSearchRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the position based on the input query\'s format
         * @summary Search for a position
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoSearch: async (query: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('geoSearch', 'query', query)
            const localVarPath = `/api/nora/geo/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a latitude and longitude coordinate from an address search
         * @summary Get coordinates from an address search
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocode: async (query: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('geocode', 'query', query)
            const localVarPath = `/api/nora/geo/address-to-coordinates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a route composed of latitude and longitude points
         * @summary Get a route
         * @param {GetRouteRequestDTO} getRouteRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute: async (getRouteRequestDTO: GetRouteRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getRouteRequestDTO' is not null or undefined
            assertParamExists('getRoute', 'getRouteRequestDTO', getRouteRequestDTO)
            const localVarPath = `/api/nora/geo/route`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getRouteRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns coordinates using the what3words format
         * @summary Search using what3words
         * @param {string} words 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhat3WordsCoordinates: async (words: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'words' is not null or undefined
            assertParamExists('getWhat3WordsCoordinates', 'words', words)
            const localVarPath = `/api/nora/geo/what-3-words/coordinates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (words !== undefined) {
                localVarQueryParameter['words'] = words;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the three words from what3words based on latitude and longitude coordinates
         * @summary Get the what3words words from coordinates
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhat3WordsWords: async (latitude: number, longitude: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getWhat3WordsWords', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getWhat3WordsWords', 'longitude', longitude)
            const localVarPath = `/api/nora/geo/what-3-words/words`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an address from a latitude and longitude coordinate
         * @summary Search for an address given coordinates
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseGeocode: async (latitude: number, longitude: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('reverseGeocode', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('reverseGeocode', 'longitude', longitude)
            const localVarPath = `/api/nora/geo/coordinates-to-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoApi - functional programming interface
 */
export const GeoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeoApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the position based on the query and additional body parameters.
         * @summary Search for a position, with additional options
         * @param {AdvancedGeocodeSearchRequestDTO} advancedGeocodeSearchRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complexGeoSearch(advancedGeocodeSearchRequestDTO: AdvancedGeocodeSearchRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplexGeoSearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complexGeoSearch(advancedGeocodeSearchRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.complexGeoSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the position based on the input query\'s format
         * @summary Search for a position
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geoSearch(query: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeoSearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geoSearch(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.geoSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a latitude and longitude coordinate from an address search
         * @summary Get coordinates from an address search
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geocode(query: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Geocode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geocode(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.geocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a route composed of latitude and longitude points
         * @summary Get a route
         * @param {GetRouteRequestDTO} getRouteRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoute(getRouteRequestDTO: GetRouteRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoute200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoute(getRouteRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns coordinates using the what3words format
         * @summary Search using what3words
         * @param {string} words 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhat3WordsCoordinates(words: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhat3WordsCoordinates200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhat3WordsCoordinates(words, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getWhat3WordsCoordinates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the three words from what3words based on latitude and longitude coordinates
         * @summary Get the what3words words from coordinates
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhat3WordsWords(latitude: number, longitude: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhat3WordsWords200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhat3WordsWords(latitude, longitude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getWhat3WordsWords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an address from a latitude and longitude coordinate
         * @summary Search for an address given coordinates
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reverseGeocode(latitude: number, longitude: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReverseGeocode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reverseGeocode(latitude, longitude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.reverseGeocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeoApi - factory interface
 */
export const GeoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeoApiFp(configuration)
    return {
        /**
         * Returns the position based on the query and additional body parameters.
         * @summary Search for a position, with additional options
         * @param {GeoApiComplexGeoSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complexGeoSearch(requestParameters: GeoApiComplexGeoSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComplexGeoSearch200Response> {
            return localVarFp.complexGeoSearch(requestParameters.advancedGeocodeSearchRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the position based on the input query\'s format
         * @summary Search for a position
         * @param {GeoApiGeoSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geoSearch(requestParameters: GeoApiGeoSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeoSearch200Response> {
            return localVarFp.geoSearch(requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a latitude and longitude coordinate from an address search
         * @summary Get coordinates from an address search
         * @param {GeoApiGeocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocode(requestParameters: GeoApiGeocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Geocode200Response> {
            return localVarFp.geocode(requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a route composed of latitude and longitude points
         * @summary Get a route
         * @param {GeoApiGetRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute(requestParameters: GeoApiGetRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetRoute200Response> {
            return localVarFp.getRoute(requestParameters.getRouteRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns coordinates using the what3words format
         * @summary Search using what3words
         * @param {GeoApiGetWhat3WordsCoordinatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhat3WordsCoordinates(requestParameters: GeoApiGetWhat3WordsCoordinatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetWhat3WordsCoordinates200Response> {
            return localVarFp.getWhat3WordsCoordinates(requestParameters.words, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the three words from what3words based on latitude and longitude coordinates
         * @summary Get the what3words words from coordinates
         * @param {GeoApiGetWhat3WordsWordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhat3WordsWords(requestParameters: GeoApiGetWhat3WordsWordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetWhat3WordsWords200Response> {
            return localVarFp.getWhat3WordsWords(requestParameters.latitude, requestParameters.longitude, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an address from a latitude and longitude coordinate
         * @summary Search for an address given coordinates
         * @param {GeoApiReverseGeocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reverseGeocode(requestParameters: GeoApiReverseGeocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReverseGeocode200Response> {
            return localVarFp.reverseGeocode(requestParameters.latitude, requestParameters.longitude, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for complexGeoSearch operation in GeoApi.
 */
export interface GeoApiComplexGeoSearchRequest {
    readonly advancedGeocodeSearchRequestDTO: AdvancedGeocodeSearchRequestDTO
}

/**
 * Request parameters for geoSearch operation in GeoApi.
 */
export interface GeoApiGeoSearchRequest {
    readonly query: string
}

/**
 * Request parameters for geocode operation in GeoApi.
 */
export interface GeoApiGeocodeRequest {
    readonly query: string
}

/**
 * Request parameters for getRoute operation in GeoApi.
 */
export interface GeoApiGetRouteRequest {
    readonly getRouteRequestDTO: GetRouteRequestDTO
}

/**
 * Request parameters for getWhat3WordsCoordinates operation in GeoApi.
 */
export interface GeoApiGetWhat3WordsCoordinatesRequest {
    readonly words: string
}

/**
 * Request parameters for getWhat3WordsWords operation in GeoApi.
 */
export interface GeoApiGetWhat3WordsWordsRequest {
    readonly latitude: number

    readonly longitude: number
}

/**
 * Request parameters for reverseGeocode operation in GeoApi.
 */
export interface GeoApiReverseGeocodeRequest {
    readonly latitude: number

    readonly longitude: number
}

/**
 * GeoApi - object-oriented interface
 */
export class GeoApi extends BaseAPI {
    /**
     * Returns the position based on the query and additional body parameters.
     * @summary Search for a position, with additional options
     * @param {GeoApiComplexGeoSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public complexGeoSearch(requestParameters: GeoApiComplexGeoSearchRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).complexGeoSearch(requestParameters.advancedGeocodeSearchRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the position based on the input query\'s format
     * @summary Search for a position
     * @param {GeoApiGeoSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public geoSearch(requestParameters: GeoApiGeoSearchRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).geoSearch(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a latitude and longitude coordinate from an address search
     * @summary Get coordinates from an address search
     * @param {GeoApiGeocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public geocode(requestParameters: GeoApiGeocodeRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).geocode(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a route composed of latitude and longitude points
     * @summary Get a route
     * @param {GeoApiGetRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoute(requestParameters: GeoApiGetRouteRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getRoute(requestParameters.getRouteRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns coordinates using the what3words format
     * @summary Search using what3words
     * @param {GeoApiGetWhat3WordsCoordinatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWhat3WordsCoordinates(requestParameters: GeoApiGetWhat3WordsCoordinatesRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getWhat3WordsCoordinates(requestParameters.words, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the three words from what3words based on latitude and longitude coordinates
     * @summary Get the what3words words from coordinates
     * @param {GeoApiGetWhat3WordsWordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWhat3WordsWords(requestParameters: GeoApiGetWhat3WordsWordsRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getWhat3WordsWords(requestParameters.latitude, requestParameters.longitude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an address from a latitude and longitude coordinate
     * @summary Search for an address given coordinates
     * @param {GeoApiReverseGeocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reverseGeocode(requestParameters: GeoApiReverseGeocodeRequest, options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).reverseGeocode(requestParameters.latitude, requestParameters.longitude, options).then((request) => request(this.axios, this.basePath));
    }
}

